import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Box, Button, IconButton } from "@mui/material";
import { RequestMode } from "@/types/common";
import { RowResponseType } from "@/types/view";
import { ApiConstant, AppConstant, LangConstant } from "@/const";
import { StatusExternalRequest, StatusInternalRequest, StatusQueryResponse } from "@/components/common";
import { GridColDef } from "@/components/common/AppTable/AppTable";
import { Fragment } from "react";
import { RemoveRedEye } from "@mui/icons-material";
import { STATUS_REQUEST } from "@/const/system.const";

const useResponseColumn = ({ setDataSelected }: any) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  const columnList: GridColDef<RowResponseType>[] = [
    {
      field: "transferResponseUid",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.requestID"),
      align: "left",
    },
    {
      field: "applicationSendName",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.application"),
      align: "center",
    },
    {
      field: "requestCreated",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.createdAt"),
      align: "center",
      render: (cell: RowResponseType) => {
        return (
          cell.requestCreated && (
            <Box>
              {dayjs(cell.requestCreated).format(AppConstant.FM_SHORT_DATE)}
              <br />
              {dayjs(cell.requestCreated).format(AppConstant.FM_FULL_HOUR)}
            </Box>
          )
        );
      },
    },
    {
      field: "responseCreated",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.responseAt"),
      align: "center",
      render: (cell: RowResponseType) => {
        return (
          cell.responseCreated && (
            <Box>
              {dayjs(cell.responseCreated).format(AppConstant.FM_SHORT_DATE)}
              <br />
              {dayjs(cell.responseCreated).format(AppConstant.FM_FULL_HOUR)}
            </Box>
          )
        );
      },
    },
    {
      field: "requestStatus",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.status"),
      align: "center",
      render: (cell: RowResponseType) => (
        <Fragment>
          <StatusQueryResponse status={cell.requestStatus} />
        </Fragment>
      ),
    },
    {
      field: "responseStatus",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.responseStatus"),
      align: "center",
      render: (cell: RowResponseType) => (
        <Fragment>
          <StatusQueryResponse status={cell.requestStatus} />
        </Fragment>
      ),
    },
    {
      field: "action",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.action"),
      align: "center",
      render: (cell: RowResponseType) => (
        <Fragment>
          <IconButton
            onClick={() =>
              setDataSelected({
                mode: "view",
                data: cell,
              })
            }
          >
            <RemoveRedEye />
          </IconButton>
        </Fragment>
      ),
    },
  ];

  return {
    columnList,
  };
};

export default useResponseColumn;
